export const SIDEBAR_OPEN = "SIDEBAR_OPEN";
export const SIDEBAR_CLOSE = "SIDEBAR_CLOSE";

export const MODAL_OPEN = "MODAL_OPEN";
export const MODAL_CLOSE = "MODAL_CLOSE";

export const GET_PROJECTS_BEGIN = "GET_PROJECTS_BEGIN";
export const GET_PROJECTS_SUCCESS = "GET_PROJECTS_SUCCESS";
export const GET_PROJECTS_ERROR = "GET_PROJECTS_ERROR";

export const GET_SERVICES_BEGIN = "GET_SERVICES_BEGIN";
export const GET_SERVICES_SUCCESS = "GET_SERVICES_SUCCESS";
export const GET_SERVICES_ERROR = "GET_SERVICES_ERROR";

export const GET_TECHNOLOGIES_BEGIN = "GET_TECHNOLOGIES_BEGIN";
export const GET_TECHNOLOGIES_SUCCESS = "GET_TECHNOLOGIES_SUCCESS";
export const GET_TECHNOLOGIES_ERROR = "GET_TECHNOLOGIES_ERROR";

export const GET_EXPERIENCES_BEGIN = "GET_EXPERIENCES_BEGIN";
export const GET_EXPERIENCES_SUCCESS = "GET_EXPERIENCES_SUCCESS";
export const GET_EXPERIENCES_ERROR = "GET_EXPERIENCES_ERROR";
